export default "__VITE_ASSET__unKKSSJN__";